var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.8135,
    cy: 16.6741,
    r: 16.5,
    fill: "#FFE1EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5684 10.5069C25.4721 10.2835 25.2553 10.1427 25.0185 10.1427H12.2157V8.31374C12.2157 7.97025 11.9469 7.69303 11.6137 7.69303C11.2806 7.69303 11.0117 7.97025 11.0117 8.31374L11.0117 25.0346C11.0117 25.378 11.2806 25.6553 11.6137 25.6553C11.9469 25.6553 12.2157 25.378 12.2157 25.0346L12.2157 20.6038H25.0185C25.2553 20.6038 25.4721 20.459 25.5684 20.2356C25.6647 20.0162 25.6286 19.7555 25.4721 19.5693L21.8841 15.3733L25.4721 11.1731C25.6286 10.9911 25.6647 10.7304 25.5684 10.5069Z",
    fill: "#F50057"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedFlag);
export default __webpack_public_path__ + "static/media/red-flag.3daa415c53f6d6657fa3153a24b3741d.svg";
export { ForwardRef as ReactComponent };